/**
 * Enter/exit motion for anchored popovers driven by `useRetainedMotionState`:
 * set `data-state` on the element and add these classes plus the origin for its placement.
 */
export const POPOVER_MOTION_CLASS = [
    'transition-[opacity,scale] duration-normal ease-out motion-reduce:transition-opacity',
    'data-[state=open]:opacity-100 data-[state=open]:scale-100',
    'data-[state=closed]:pointer-events-none data-[state=closed]:opacity-0 data-[state=closed]:scale-95 data-[state=closed]:duration-fast',
    'motion-reduce:data-[state=closed]:scale-100'
].join(' ')

const ORIGIN_BY_PLACEMENT: Record<string, string> = {
    'bottom-start': 'origin-top-left',
    'bottom-end': 'origin-top-right',
    bottom: 'origin-top',
    'top-start': 'origin-bottom-left',
    'top-end': 'origin-bottom-right',
    top: 'origin-bottom',
    'left-start': 'origin-right',
    'left-end': 'origin-right',
    left: 'origin-right',
    'right-start': 'origin-left',
    'right-end': 'origin-left',
    right: 'origin-left'
}

/** Grows the popover out of the edge that touches its trigger. */
export const getPopoverOriginClass = (placement: string): string => ORIGIN_BY_PLACEMENT[placement] ?? 'origin-top'
